import { CreateAccommodationReservationModal } from "Bands/containers/CreateAccommodationBlockForm/CreateAccommodationReservationModal";
import { IAccommodationBlock } from "Bands/types";
import { FC, useState } from "react";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Button } from "shared/components";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const { accommodationBlock: blockCopy } = copy;

interface Props {
  block: IAccommodationBlock;
}

export const AddAccommodationReservation: FC<Props> = ({ block }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        data-testid={"add_accommodation_reservation"}
        onClick={() => setShowModal(true)}
        theme={ITheme.secondary}
        size="m"
      >
        <Icon as={Plus} /> {" " + blockCopy.create.peopleBlock.fields.title}
      </Button>
      {showModal && (
        <CreateAccommodationReservationModal
          block={block}
          handleClose={() => setShowModal(false)}
        ></CreateAccommodationReservationModal>
      )}
    </>
  );
};
